import React from 'react'
import { Chart } from 'react-google-charts'

export default function Graph(props) {
	const data = props.data
	let formatedData = []
	if (data.length !== 0) {
		formatedData = data.map(d => [d.title, d.count])
		formatedData.unshift(['Title', ''])
	}


	return (
		<React.Fragment>
			{
				data.length !== 0 ?
					<Chart
						width={props.width !== null ? props.width : '450px'}
						height={props.height !== null ? props.height : '250px'}
						chartType={props.type ? props.type : "BarChart"}
						loader={<div>Loading...</div>}
						data={
							formatedData
						}
						options={{
							isStacked: true,
							chartArea: props.chartArea !== null ? props.chartArea : null,
							hAxis: {
								title: props.type === 'LineChart' ? props.vAxisTitle : 'Employees Count',
								minValue: 0,
							},
							vAxis: {
								title: props.type === 'LineChart' ? 'Employees Count' : props.vAxisTitle,
								minValue: 0,
							},
							legend: "none"
						}}
					/> : null
			}
		</React.Fragment>

	)
}
